/* tslint:disable */
/* eslint-disable */
/**
 * Control Online API
 * Control Online API
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FundWithdrawRequestDto
 */
export interface FundWithdrawRequestDto {
  /**
   *
   * @type {number}
   * @memberof FundWithdrawRequestDto
   */
  amount: number;
}

export function FundWithdrawRequestDtoFromJSON(json: any): FundWithdrawRequestDto {
  return FundWithdrawRequestDtoFromJSONTyped(json, false);
}

export function FundWithdrawRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FundWithdrawRequestDto {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    amount: json["amount"],
  };
}

export function FundWithdrawRequestDtoToJSON(value?: FundWithdrawRequestDto | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    amount: value.amount,
  };
}
